import { Text } from "../../../";
import { format } from "date-fns";
import * as React from "react";

import { INote } from "../types/INote";
import { useNoteStyles } from "./notes.styles";

export const Note = React.memo((props: { baseId: string; note: INote }) => {
    const classes = useNoteStyles({});

    const { note, baseId } = props;

    return (
        <div className={classes.root} id={baseId}>
            {note.jobName ? (
                <div className={classes.subject}>
                    <Text variant="h3">{note.jobName}</Text>
                </div>
            ) : null}
            <div className={classes.audit} id={`${baseId}Audit`}>
                <span>{note.authorNameWithInitial}</span>
                <span>{format(note.createTimestamp, "P p")}</span>
            </div>
            <div className={classes.body} id={`${baseId}Body`}>
                {note.body}
            </div>
        </div>
    );
});
